import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/material/styles';
import Fade from '@mui/material/Fade';

// Custom styled TabList for a more modern appearance
const StyledTabList = styled(TabList)(({ theme }) => ({
  borderBottom: '1px solid',
  borderColor: 'divider',
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: 3,
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
  },
  '& .MuiTab-root': {
    textTransform: 'none',
    minWidth: 0,
    padding: '12px 16px',
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.secondary,
    transition: 'all 0.2s',
    '&.Mui-selected': {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
    },
    '&:hover': {
      color: theme.palette.primary.main,
      opacity: 1,
    },
  },
}));

// Custom styled TabPanel for better content presentation
const StyledTabPanel = styled(TabPanel)(({ theme }) => ({
  padding: theme.spacing(3, 0),
}));

export default function DynamicTabs({ tabs, icon }) {
  const [value, setValue] = React.useState(tabs[0]?.value); // Initialize with the value of the first tab

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box>
          <StyledTabList 
            onChange={handleChange} 
            aria-label="dynamic tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map(tab => (
              <Tab 
                key={tab.value}
                icon={icon}
                label={tab.label}
                value={tab.value}
                disableRipple
              />
            ))}
          </StyledTabList>
        </Box>
        {tabs.map(tab => (
          <Fade key={tab.value} in={value === tab.value} timeout={300}>
            <div>
              <StyledTabPanel value={tab.value}>
                {tab.content}
              </StyledTabPanel>
            </div>
          </Fade>
        ))}
      </TabContext>
    </Box>
  );
}
